function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.113 11.71h1.235s.373-.04.564-.245c.175-.188.17-.541.17-.541s-.024-1.653.745-1.897c.758-.24 1.732 1.598 2.765 2.305.78.534 1.373.417 1.373.417l2.76-.038s1.445-.09.76-1.221c-.056-.093-.399-.838-2.053-2.369-1.73-1.602-1.498-1.343.586-4.114 1.27-1.688 1.778-2.718 1.619-3.16-.151-.42-1.085-.309-1.085-.309l-3.108.02s-.23-.032-.401.07c-.167.1-.274.333-.274.333s-.492 1.306-1.148 2.416c-1.384 2.344-1.938 2.468-2.164 2.322-.526-.339-.395-1.362-.395-2.09 0-2.27.346-3.217-.672-3.463-.338-.08-.587-.135-1.45-.143C8.83-.01 7.891.006 7.36.266c-.353.172-.626.557-.46.58.206.026.67.124.917.459.319.432.308 1.403.308 1.403s.183 2.673-.428 3.005c-.419.228-.993-.237-2.227-2.363-.632-1.09-1.11-2.293-1.11-2.293S4.27.832 4.105.71A1.286 1.286 0 003.627.52L.674.54S.23.55.068.742c-.145.171-.012.525-.012.525s2.312 5.395 4.93 8.113c2.401 2.493 5.127 2.33 5.127 2.33",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgVk;